import * as React from "react";
import * as cls from "./Form.module.scss";
export { FormActions } from "./FormActions.jsx";
export { Form };
/**
 * Форма.
 * @param {Object} props - Атрибуты элемента.
 * @property {"column"|"row"|"grid"} [props.layout="column"] - Макет формы.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {string} [props.action] - Адрес отправки.
 * @param {string} [props.method] - "GET" или "POST".
 * @param {EventListener} [props.onSubmit] - При отправке формы.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example EventHandler
 * import {Form} from "../personal-studio-components/form/index.js";
 * <Form onSubmit={(event) => {event.preventDefault();}}>...</Form>
 * @see {@link ../frame/EventListener.js}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Form({
  layout = "column",
  className,
  action,
  method,
  onSubmit,
  children,
  formRef,
}) {
  let fullClassName = cls.form + " " + cls["form_layout_" + layout];
  if (className) fullClassName += " " + className;
  return (
    <form
      ref={formRef}
      action={action}
      method={method}
      className={fullClassName}
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
}
/**
 * Типы форм.
 * @enum {string}
 * @inner
 */
Form.Type = {
  /** По умолчанию. */
  DEFAULT: "default",
};
